/**
 * Service for managing video share links
 */

/**
 * Generate a share URL for a video using its short ID
 * @param {string} shortId - The short ID of the share link
 * @returns {string} The full share URL
 */
export const generateShareUrl = (shortId) => {
  return `${window.location.origin}/#/share/video/${shortId}`;
};

/**
 * Copy a share URL to the clipboard
 * @param {string} shortId - The short ID of the share link
 * @returns {Promise<string>} The copied URL
 */
export const copyShareUrl = async (shortId) => {
  const shareUrl = generateShareUrl(shortId);
  await navigator.clipboard.writeText(shareUrl);
  return shareUrl;
};

/**
 * Format a share URL as HTML with a link
 * @param {string} shortId - The short ID of the share link
 * @returns {string} HTML formatted link
 */
export const formatShareUrlAsHtml = (shortId) => {
  const shareUrl = generateShareUrl(shortId);
  return `<a href="${shareUrl}" target="_blank" rel="noopener noreferrer">${shareUrl}</a>`;
};
